import { N800, N0, N600, N100, N400 } from '@atlaskit/theme/colors';
import React, { useContext } from 'react';
import { type Theme } from './types';
import { token } from '@atlaskit/tokens';

export const whiteTheme: Theme = {
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	name: 'white',
	type: 'light',
	background: {
		color: token('elevation.surface', N0),
	},
	color: {
		primary: token('color.text', N800),
		secondary: token('color.text', N800),
	},
	navigation: {
		icon: {
			textColor: token('color.text.subtle', N400),
			color: token('color.icon', N100),
			gradientStart: token('color.icon', N600),
			gradientStop: token('color.icon.accent.gray', N100),
		},
	},
};

export const ThemeContext = React.createContext<Theme>(whiteTheme);
export const useThemeContext = () => useContext(ThemeContext);
